<div class="timeline noselect"
     [ngClass]="{'disabled': isTimelineDisabled, 'mobile-timeline': enableMobileFullscreen, 'desktop-timeline': !enableMobileFullscreen}">
    <eocm-bar *ngIf="!enableMobileFullscreen; else mobileDevice" [showBar]="!playerConfig?.hideTimelineProgressBar" class="seek-bar"></eocm-bar>
    <ng-template #mobileDevice>
        <div class="mobile-view">
            <eocm-bar [showBar]="!playerConfig?.hideTimelineProgressBar" class="seek-bar"></eocm-bar>
            <eocm-full-screen [isMobileDevice]="enableMobileFullscreen" class="mobile-full-screen"></eocm-full-screen>
        </div>
    </ng-template>
    <div [ngClass]="{'no-display': isInMobilePreviewMode, 'row-icon-group': !isInMobilePreviewMode }">
        <div class="column-icon-group">
            <eocm-play-pause></eocm-play-pause>
            <eocm-volume *ngIf="!isDeviceWithVolumeControl()"></eocm-volume>
            <div *ngIf="!playerConfig?.hideVideoTimeDuration">
                <eocm-timer [type]="1"></eocm-timer>
                <span class="time-divider"> / </span>
                <eocm-timer [type]="2"></eocm-timer>
            </div>
        </div>
        <div class="column-icon-group">
            <eocm-resolution></eocm-resolution>
            <eocm-full-screen [isMobileDevice]="enableMobileFullscreen" *ngIf="isFullScreenSupported()"></eocm-full-screen>
        </div>
    </div>
</div>
